// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeOffPolicies_wrapper__tKCvs","controls":"TimeOffPolicies_controls__mrPv4","searchWrapper":"TimeOffPolicies_searchWrapper__UDtNs"};